import { useState, useEffect } from "react";
import { store } from "statorgfc";

export function useStore(key) {
  const [state, setState] = useState(
    Object.keys(store._store).includes(key) ? store.get(key) : undefined
  );

  useEffect(() => {
    const unsubscribe = store.subscribe(keys => {
      if (!keys.includes(key)) return;
      setState(store.get(key));
    });
    return () => unsubscribe();
  }, []);

  function setStore(store) {
    store.set(key, state);
  }

  return [state, setStore];
}
